/**
 * Login.tsx — Página de login via Firebase Auth
 */

import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/auth'

export function Login() {
  const { signIn } = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await signIn(email, password)
      navigate('/', { replace: true })
    } catch (err) {
      setError(
        err instanceof Error
          ? 'Email ou senha inválidos.'
          : 'Erro ao fazer login.'
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'radial-gradient(ellipse at center, #0f0f2e 0%, #080810 70%)',
      }}
    >
      <div
        style={{
          width: '360px',
          background: 'rgba(13, 13, 30, 0.95)',
          border: '1px solid rgba(87, 245, 195, 0.2)',
          borderRadius: '12px',
          padding: '40px 32px',
          backdropFilter: 'blur(20px)',
          boxShadow: '0 0 60px rgba(87, 245, 195, 0.08)',
        }}
      >
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div
            style={{
              fontSize: '28px',
              fontWeight: 800,
              color: '#57f5c3',
              letterSpacing: '0.05em',
              marginBottom: '8px',
            }}
          >
            AI BAM
          </div>
          <div style={{ fontSize: '13px', color: '#5a5a80' }}>
            Vault Web — Base de Conhecimento
          </div>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label style={{ fontSize: '12px', color: '#9090b0', display: 'block', marginBottom: '6px' }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="seu@email.com"
              style={{ width: '100%' }}
              autoFocus
            />
          </div>

          <div>
            <label style={{ fontSize: '12px', color: '#9090b0', display: 'block', marginBottom: '6px' }}>
              Senha
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              style={{ width: '100%' }}
            />
          </div>

          {error && (
            <div
              style={{
                fontSize: '12px',
                color: '#E91E63',
                padding: '8px 12px',
                background: 'rgba(233, 30, 99, 0.1)',
                borderRadius: '6px',
                border: '1px solid rgba(233, 30, 99, 0.2)',
              }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary"
            style={{ width: '100%', padding: '10px', fontSize: '14px', marginTop: '4px' }}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div style={{ marginTop: '24px', fontSize: '11px', color: '#5a5a80', textAlign: 'center' }}>
          Acesso restrito à equipe BAM.
          <br />
          Solicite acesso ao Natan.
        </div>
      </div>
    </div>
  )
}
